/* eslint-disable no-use-before-define */

export const statusColor = (status) => {
   switch (status) {
      case 0:
         return 'created-order'
      case 1:
         return 'waiting-for-aproval'
      case 2:
         return 'payment-complete'
      case 3:
         return 'payment-declined'
      case 4:
         return 'refunded-payment'
      case 6:
         return 'ok'
      case 7:
         return 'in-force'
      case 8:
         return 'completed'
      case 9:
         return 'late'
      case 10:
         return 'reported-by-owner'
      case 11:
         return 'user-reported'
      case 12:
         return 'you-canceled'
      case 13:
         return 'canceled-by-user'
      case 14:
         return 'canceled-by-system'
      case 15:
         return 'change-of-dates'
      case 17:
         return 'disapproved-date-changes'
      case 18:
         return 'late_order_1st_additional_charge'
      case 19:
         return 'late_order_2nd_additional_charge'
      case 20:
         return 'late_order_full_bike_charge'
      case 21:
         return 'late_order_custom_value_charge'
      default:
         return 'info'
   }
}

export const setStatus = (status) => {
   return (status === 0) ? 'Pedido Criado' :
      (status === 1) ? 'Aguardando Aprovação' :
         (status === 2) ? 'Pagamento Concluído' :
            (status === 3) ? 'Pagamento Recusado' :
               (status === 4) ? 'Pagamento Estornado' :
                  (status === 5) ? 'Aguardando a sua Aprovação' :
                     (status === 6) ? 'Aguardando Checkin' :
                        (status === 7) ? 'Em Vigor' :
                           (status === 8) ? 'Concluído' :
                              (status === 9) ? 'Atrasado!' :
                                 (status === 10) ? 'Reportado pelo Anfitrião' :
                                    (status === 11) ? 'Reportado pelo Ciclista' :
                                       (status === 12) ? 'Cancelado pelo Anfitrião' :
                                          (status === 13) ? 'Cancelado' :
                                             (status === 14) ? 'Cancelado pelo Sistema' :
                                                (status === 15) ? 'Alteração de Datas' :
                                                   (status === 17) ? 'Cancelado - Alteração de Datas Recusado' :
                                                      (status === 18) ? 'Atraso na Entrega - 1ª cobrança de diária adicional' :
                                                         (status === 19) ? 'Atraso na Entrega - 2ª cobrança de diária adicional' :
                                                            (status === 20) ? 'Atraso na Entrega - Cobrança integral da bike' :
                                                               (status === 21) ? 'Atraso na Entrega -  Cobrança de valor personalizado' : ''
}

export const statusJuno = (status) => {
   let st
   switch (status) {
      case 'DECLINED':
         st = "REJEITADO"
         break
      case 'FAILED':
         st = "NÃO REALIZADO"
         break
      case 'NOT_AUTHORIZED':
         st = "NÃO AUTORIZADO"
         break
      case 'CONFIRMED':
         st = "CONFIRMADO"
         break
      case 'CUSTOMER_PAID_BACK':
         st = "PAGAMENTO ESTORNADO"
         break
      case 'BANK_PAID_BACK':
         st = "PAGO AO BANCO"
         break
      case 'PARTIALLY_REFUNDED':
         st = "ESTORNO PARCIAL"
         break
      default:
         st = status
   }
   return st
}
